<template lang="pug">
v-app
  v-app-bar(
    color="#1c3f4c"
    dark
    app
  )
    v-toolbar-title
      v-img(
        :src="require('@/assets/logo.png')"
        contain
        width="280"
      )
    v-spacer
    div(class="d-flex align-center")
      v-menu(
        v-model="userBox"
        :close-on-content-click="false"
        offset-y
        offset-x
      )
        template(v-slot:activator="{ on, attrs }")
          v-avatar(color="indigo" size="40" v-bind="attrs" v-on="on")
            v-icon(dark) mdi-account-circle
        v-card(
          class="pa-3"
          min-width="200"
        )
          v-btn(
            @click="logout"
            class="my-1"
            color="blue-grey"
            dark
            block
          ) 登出
  v-main  
    router-view
</template>

<script>
export default {
  name: 'Main',
  data: () => ({
    userBox: false
  }),
  methods: {
    logout () {
      this.$store.dispatch('auth/setAuth', {
        token: '',
        isLogin: false
      })
      this.$router.push('/');
    }
  }
}
</script>
